import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';
import FeaturedProjectCard from '../components/FeaturedProjectCard';

function Projects() {
  const featuredProjects = [
    {
      title: 'RBC Bank Data Pipeline',
      description:
        'Robust data pipeline for RBC Bank that extracted, validated, and transformed unstructured text files during a major branch acquisition. We were able to steer them away from unnecessarily heavy-handed AI solutions. Instead, we delivered clean, correct, and simple results - ahead of time and under budget.',
      image: '/img/RBC.png',
      tech: ['Python', 'Regex', 'Pandas', 'Pytest', 'Git'],
      demo: null,
    },
    {
      title: 'Crafted By Collins Webpage',
      description:
        'Professional website showcasing woodworking and custom furniture projects. Complete brand identity package including logo, color palette, and visual guidelines. Automated email marketing and SEO optimization drive client engagement and online visibility.',
      image: '/img/cbyc_full.jpg',
      tech: ['WordPress', 'Cloudways', 'Email Automation', 'SEO Plugins'],
      demo: 'https://craftedbyCollins.com',
    },
    {
      title: 'Auction Site Web Scraper',
      description:
        'Automated web scraping solution deployed for a robotics company that continuously monitors multiple auction sites, extracting real-time data and enabling efficient market analysis. The system dramatically reduced manual auction review times and provided competitive intelligence. Deployed with PostgreSQL persistence and time-series tracking for historical analysis.',
      image: '/img/bidspotter.png',
      tech: [
        'Python',
        'BeautifulSoup',
        'Playwright',
        'Streamlit',
        'Flask',
        'PostgreSQL',
        'Pytest',
        'Git',
        'GitHub Actions',
        'Docker',
      ],
      demo: null,
    },
    {
      title: 'MV Concrete Webpage',
      description:
        'Professional website featuring concrete and landscaping projects with comprehensive service offerings. Full brand identity including custom logo, color scheme, and visual standards. Strategic SEO and automated client communication enhance lead generation and search rankings.',
      image: '/img/MV_logo.png',
      tech: ['WordPress', 'Cloudways', 'Yoast', 'WPMail', 'SEO Plugins'],
      demo: 'https://mvconcrete.ca',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            // Unobserve after visibility to prevent repeated callbacks
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -100px 0px' }
    );

    const sections = document.querySelectorAll('.animate-on-scroll');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="container projects-page">
      <h1 className="page-title">Projects</h1>
      <p className="page-intro">Recent projects and case studies from our client engagements.</p>
      <section
        aria-labelledby="featured-projects-heading"
        className="featured-section animate-on-scroll"
      >
        <h2 id="featured-projects-heading">Featured Client Projects</h2>
        <div className="card-grid">
          {featuredProjects.map((proj, idx) => (
            <div
              key={idx}
              className="animate-on-scroll"
              style={{ transitionDelay: `${idx * 0.15}s` }}
            >
              <FeaturedProjectCard {...proj} />
            </div>
          ))}
        </div>
        <div className="projects-more animate-on-scroll">
          <div className="projects-more-content">
            <h3>Growing Portfolio</h3>
            <p>
              We're early in our journey, but consistently expanding our portfolio. Check back soon
              for updates! 😊
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="home-cta-section animate-on-scroll" aria-labelledby="cta-heading">
        <div className="container">
          <div className="card cta-card">
            <h2 id="cta-heading">Ready to Get Started?</h2>
            <p>Let's discuss how we can help transform your business.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
              <Link to="/services" className="btn btn-secondary">
                View Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Projects;
